import React from "react";
import { Grid, Typography, Button } from "@mui/material";
// styles
import useStyles from "./styles";
import { NotFoundImageIcon } from "../../providers/RexIconsSVG/RexIconsSVG";
import { useI18n } from "../../providers/I18n/I18n";

const Link = ({ className, children }) => {
  return (
    <a className={className} href={"/"}>
      {children}
    </a>
  );
};

export default function ErrorSomethingWrong() {
  const classes = useStyles();
  const { t } = useI18n();
  return (
    <Grid container className={classes.container}>
      <NotFoundImageIcon />
      <Typography variant="h2" color="black" className={classes.textRowTitle}>
        {t("pageNotFound")}
      </Typography>
      <Typography variant="subtitle1" color="black" className={classes.textRow}>
      {t("contentDoesNotExists")}
      <br />
      {t("updatedVersionJustLoaded")}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        component={Link}
        size="large"
        className={classes.backButton}
      >
        Back to Home
      </Button>
    </Grid>
  );
}
